export default "__VITE_ASSET__bdd79ed6__"